import { render, staticRenderFns } from "./MILIDWave.vue?vue&type=template&id=200fc65b&scoped=true&"
import script from "./MILIDWave.vue?vue&type=script&lang=ts&"
export * from "./MILIDWave.vue?vue&type=script&lang=ts&"
import style0 from "./MILIDWave.vue?vue&type=style&index=0&id=200fc65b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200fc65b",
  null
  
)

export default component.exports